export enum EOfferSpendByAccountView {
	Day = 'day',
	Month = 'month',
}

export const OFFER_SPEND_BY_ACCOUNT_VIEW_LABEL_MAP: Record<EOfferSpendByAccountView, string> = {
	[EOfferSpendByAccountView.Day]: `offer_spend_by_account_view.${EOfferSpendByAccountView.Day}`,
	[EOfferSpendByAccountView.Month]: `offer_spend_by_account_view.${EOfferSpendByAccountView.Month}`
}
